module.exports = __webpack_public_path__ + "static/media/Roboto-MediumItalic.cabdb4a1.ttf";